import { useEffect, useState } from "react";
import ModalComponent from "../common/Modal/modal";
import { FIELD_TYPES, FieldItem } from "../../widgets/fields";
import useFieldItem from "../../widgets/fields/UseFieldItem";
import { CustomButton, showToaster, toasterTypes } from "../../widgets";
import { getTargetFormList } from "./apiController";

export default function UidAddDataModal(props) {
     const [forms, Setforms] = useState([]);
     const { formData, action } = props;
     const [values, fields, handleChange, { validateValues, reset, updateValue, resetValue, updateError }] = useFieldItem({}, {}, { onValueChange });

     useEffect(() => {
          fetchInitialData();
     }, [])

     /**
      * fetch target form list
      * update the state with key-value
      */
     const fetchInitialData = async () => {
          try {
               let response = await getTargetFormList(formData.id);
               Setforms(response.map(({
                    id: value,
                    form_name: label
               }) => ({
                    value,
                    label
               })));
          } catch (err) {

          }
     }

     /**
      * 
      * @param name 
      * @param value 
      * @param values 
      * @param fieldValues 
      * @returns 
      */
     function onValueChange(name, value, values, fieldValues = null) {
          return [{
               ...values,
               [name]: value,
          }]
     }


     return (
          <>
               <ModalComponent
                    width={window.innerWidth > 750 ? "50%" : "100%"}
                    isOpen={true}
                    onClose={() => props.onClose()}
                    header={"View Info / View Summary"}
                    centered={true}
                    customClass='uidmodal'
                    body={
                         <>
                              <div>
                                   Do you want to proceed ?
                              </div>
                         </>
                    }
                    footer={
                         <div style={{display:"flex"}}>
                              <CustomButton type="primary" text={"View Info"} onClick={() => { props.onAdd("") }}></CustomButton>
                         </div>
                    }
               />
          </>
     )
}